import Api from "./axiosInstance"

const updateUserProfile = async (params) => {
    try {
        const response = await Api.post('/grpc/user.UserService/UpdateUserProfile', params);
        return response;
    } catch (error) {
        console.error("Error in get User profile pic API:", error);
        throw error;
    }
};

const getShipDetails = async (params) => {
    try {
        const response = await Api.post('/grpc/user.UserService/getShipDetails',params);
        return response.data;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};


const getLevel3Ranks = async (params) => {
    try {
        const response = await Api.post('/grpc/user.UserService/GetLevel3Ranks',params);
        return response.data;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};

export const profileApiServices = {
    updateUserProfile,
    getShipDetails,
    getLevel3Ranks
};

